export const arrayKeys = [
  "preReqs",
  "originFilters",
  "stateFilters",
  "campaignFilters",
];
export const paycyclesArr = ['Monthly', 'SemiMonthly', 'Biweekly', 'Weekly'];
export const objectKeys = ["decision", "denyRules", "price", "risk"];
export const dateKeys = ["activeStart", "activeEnd", "startDate", "endDate"];
export const stringKeys = [
  "name",
  "modelID",
  "sortOrder",
  "activeStart",
  "activeEnd",
  "groupID",
  "groupWeight",
  "modelType",
  "lowAmount",
  "highAmount",
];
export const locationsArr = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];
export const PreReqsArr = [
  "Ibv",
  "ClarityFraud",
  "ClarityClearBankBehavior",
  "Ekata",
  "DataXIDV",
  "DataXBAV",
  "DataXCreditReport",
  "DataXChex",
  "DataXScoreAction",
  "Neustar",
  "ClarityRecentHistory",
  "ValidiFIvFraud",
  "ValidiFIvAccountPlus",
  "ValidiFIvCredit",
  "ValidiFIvIndex",
  "Sentilink",
  "SEONFraud",
  "FT_OFAC_Check",
  "FT_IDLogic",
  "FT_Application_Check",
  "FT_Insolvency_Logic_v2",
  "FT_MLA_Check",
  "FT_TU_Traditional_Credit_Attributes",
  "FT_TU_Alternative_Credit_Attributes_v2",
  "ScoreMyCash_CashVerifi",
  "Congruit_AchExchange",
  "Congruit_Nopay3Exchange",
  "Congruit_Resolution",
  "Congruit_ResolutionVerify"
];
export const origins = [
  { originID: 0, value: "Return Customer" },
  { originID: 1, value: "Organic " },
  { originID: 2, value: "PPC " },
  { originID: 6, value: "SellingSource " },
  { originID: 7, value: "LeadFlash " },
  { originID: 12, value: "Spotya " },
  { originID: 13, value: "t3leads " },
  { originID: 19, value: "SellingSource2 " },
  { originID: 20, value: "RoundSky " },
  { originID: 21, value: "LeadClick " },
  { originID: 22, value: "LeadGenix " },
  { originID: 23, value: "LeadClick2 " },
  { originID: 24, value: "RoundSky2 " },
  { originID: 25, value: "t3leads2 " },
  { originID: 26, value: "LeadFlash2 " },
  { originID: 27, value: "LeadFlash 3" },
  { originID: 28, value: "Net Pay Advance" },
  { originID: 29, value: "Net Pay Advance New  " },
  { originID: 30, value: "NPALoan.com " },
  { originID: 31, value: "700 35 Dot818 Lead  " },
  { originID: 32, value: "701 35 Dot818 Lead  " },
  { originID: 33, value: "flexpayday.com " },
  { originID: 1000, value: "TX " },
  { originID: 1001, value: "PA " },
  { originID: 1002, value: "TX " },
  { originID: 1003, value: " " },
  { originID: 1004, value: "TX " },
  { originID: 1005, value: "PPC1005 " },
  { originID: 1006, value: "TX " },
  { originID: 1007, value: "PPC1007 " },
  { originID: 1008, value: "PPC1008 " },
  { originID: 1009, value: "PPC1009 " },
  { originID: 1010, value: "PPC1010 " },
  { originID: 1011, value: "TX " },
  { originID: 1012, value: "TX " },
  { originID: 1013, value: "PPC1013 " },
  { originID: 1014, value: "TX " },
  { originID: 1015, value: "TX " },
  { originID: 1016, value: "PPC1016 " },
  { originID: 1017, value: "PPC1017 " },
  { originID: 1018, value: "PPC1018 " },
  { originID: 1019, value: "PPC1019 " },
  { originID: 1020, value: "PPC1020 " },
  { originID: 1021, value: "PPC1021 " },
  { originID: 1022, value: "PPC1022 " },
  { originID: 1023, value: "PPC1023 " },
  { originID: 1024, value: "PPC1024 " },
  { originID: 1025, value: "ACPPC1025 " },
  { originID: 1026, value: "TX S" },
  { originID: 1027, value: "PPCGoogleTX27 " },
  { originID: 1028, value: "PPCGoogleTX28 " },
  { originID: 1029, value: "PPCGoogleTX29 " },
  { originID: 1030, value: "CA " },
  { originID: 1031, value: "CA " },
  { originID: 1032, value: "CA " },
  { originID: 1033, value: "CA " },
  { originID: 1034, value: "FB - Landing Page  " },
  { originID: 1035, value: "CA S" },
  { originID: 1036, value: "PPCGoogle33 " },
  { originID: 1037, value: "PPCGoogle34 " },
  { originID: 1038, value: "PPCGoogle35 " },
  { originID: 1039, value: "TPPC1039 " },
  { originID: 1040, value: "DecisionLogic 1 CA" },
  { originID: 1041, value: "DecisionLogic 2 TX" },
  { originID: 1042, value: "TESTING " },
  { originID: 1043, value: "Thursday " },
  { originID: 1044, value: "LA New Year" },
  { originID: 1045, value: "Spanish Ads" },
  { originID: 1046, value: "RSA AdWords Test" },
  { originID: 1047, value: "RSA AdWords Test" },
  { originID: 1048, value: "Payday Flex Search" },
  { originID: 1049, value: "Short Term Cash Loans  " },
  { originID: 1050, value: "Short Term Cash Loans  " },
  { originID: 1051, value: "Short Term Cash Loans  " },
  { originID: 1052, value: "Bing Short Term Cash Loans " },
  { originID: 1053, value: "Placer County" },
  { originID: 1054, value: "Trusted Ad Group" },
  { originID: 1055, value: "Mailchimp e-blasts" },
  { originID: 1056, value: "Short Term Cash Loans Dayparts " },
  { originID: 1057, value: "Short Term Cash Loans Dayparts " },
  { originID: 1058, value: "Bing CA Branding (Business Hours) " },
  { originID: 1059, value: "Bing CA Branding (Nights & Weekends)" },
  { originID: 1060, value: "Bing CA Cash (Nights & Weekends)" },
  { originID: 1061, value: "Bing CA Cash (Business Hours) " },
  { originID: 1062, value: "Bing CA Short Term Evening " },
  { originID: 1063, value: "Bing CA Short Term Mid-Day " },
  { originID: 1064, value: "Bing CA Short Term Overnight " },
  { originID: 1065, value: "Bing Rural CA" },
  { originID: 1066, value: "Bing CA Payday (Sat)  " },
  { originID: 1067, value: "Bing CA Payday (Business Hours) " },
  { originID: 1068, value: "Bing CA Payday (Week-nights)  " },
  { originID: 1069, value: "Bing CA Payday (Overnight)  " },
  { originID: 1070, value: "Yahoo Gemini Short Term  " },
  { originID: 1071, value: "Yahoo Gemini Payday" },
  { originID: 1072, value: "Yahoo Gemini Cash Advance  " },
  { originID: 1073, value: "RSA " },
  { originID: 1074, value: "RSA " },
  { originID: 1075, value: "RSA " },
  { originID: 1076, value: "RSA " },
  { originID: 1077, value: "RSA " },
  { originID: 1078, value: "RSA " },
  { originID: 1079, value: "RSA " },
  { originID: 1080, value: "RSA " },
  { originID: 1081, value: "RSA " },
  { originID: 1082, value: "RSA " },
  { originID: 1083, value: "Bing TX Payday Overnight  " },
  { originID: 1084, value: "Bing TX Payday Business Hours " },
  { originID: 1085, value: "Bing TX Payday Weeknighs  " },
  { originID: 1086, value: "Bing TX Saturday" },
  { originID: 1087, value: "Bing TX Cash Advance  " },
  { originID: 1088, value: "Bing TX Short Term Loan " },
  { originID: 1089, value: "Community Page" },
  { originID: 1090, value: "Facebook Display" },
  { originID: 1091, value: "Bing Branded" },
  { originID: 1092, value: "Pandora Display Ad" },
  { originID: 1093, value: "Ariel Marketing" },
  { originID: 1094, value: "Ariel Marketing" },
  { originID: 1095, value: "Ariel Marketing" },
  { originID: 1096, value: "Ariel Marketing" },
  { originID: 1097, value: "Ariel Marketing" },
  { originID: 1098, value: "Ariel Marketing" },
  { originID: 1099, value: "Ariel Marketing" },
  { originID: 1100, value: "Bing CA Direct Payday Lenders " },
  { originID: 1101, value: "TX Demo Adj" },
  { originID: 1102, value: "TX Demo Excl" },
  { originID: 1103, value: "CA Demo Adj" },
  { originID: 1104, value: "CA Demo Excl" },
  { originID: 1105, value: "TX Facebook News Feed  " },
  { originID: 1106, value: "CA Facebook News Feed  " },
  { originID: 1107, value: "TX Yahoo Gemini Payday  " },
  { originID: 1108, value: "CA Facebook Display" },
  { originID: 1109, value: "TX Facebook Display" },
  { originID: 1110, value: "CA Facebook Boosted" },
  { originID: 1111, value: "TX Facebook Boosted" },
  { originID: 1701, value: "Pre-Qual Letter 1701" },
  { originID: 1702, value: "American First Finance" },
  { originID: 1703, value: "FB Collections" },
  { originID: 1704, value: "701 35 Intimate Interactive  " },
  { originID: 1705, value: "700 1 Intimate Interactive  " },
  { originID: 1706, value: "701 35 Dot818" },
  { originID: 1707, value: "701 35 Dot818" },
  { originID: 1708, value: "701 45 Dot818" },
  { originID: 1709, value: "700 15 Dot818" },
  { originID: 1710, value: "700 35 Intimate Interactive  " },
  { originID: 1711, value: "700 10.5 Intimate Interactive  " },
  { originID: 1712, value: "700 35 Round Sky  " },
  { originID: 1713, value: "700 35 The Lead Group " },
  { originID: 1714, value: "700 3 Intimate Interactive  " },
  { originID: 1715, value: "701 45 Dot818" },
  { originID: 1716, value: "700 5 Intimate Interactive  " },
  { originID: 1717, value: "701 10 The Lead Group " },
  { originID: 1718, value: "700 40 The Lead Group " },
  { originID: 1719, value: "701 25 The Lead Group " },
  { originID: 1720, value: "701 75 The Lead Group " },
  { originID: 1721, value: "700 50 The Lead Group " },
  { originID: 1722, value: "701 20 Round Sky  " },
  { originID: 2101, value: "700 30 Intimate Interactive  " },
  { originID: 2102, value: "700 30 The Lead Group " },
  { originID: 2103, value: "700 30 Round Sky  " },
  { originID: 2104, value: "700 30 IT Media  " },
  { originID: 2105, value: "700 30 Acquire Interactive  " },
  { originID: 2106, value: "700 30 Lead Flash  " },
  { originID: 2107, value: "700 35 Intimate Interactive  " },
  { originID: 2108, value: "700 35 The Lead Group " },
  { originID: 2109, value: "700 35 Round Sky  " },
  { originID: 2110, value: "700 35 Acquire Interactive  " },
  { originID: 2111, value: "700 40 Intimate Interactive  " },
  { originID: 2112, value: "700 40 The Lead Group " },
  { originID: 2113, value: "700 40 Round Sky  " },
  { originID: 2114, value: "700 40 Acquire Interactive  " },
  { originID: 2115, value: "700 40 IT Media  " },
  { originID: 2116, value: "700 50 IT Media - Organic" },
  { originID: 2117, value: "700 20 IT Media - Non Organic" },
  { originID: 2118, value: "700 40 Acquire Interactive - Organic" },
  { originID: 2119, value: "700 20 Acquire Interactive - Non Organic" },
  { originID: 2120, value: "700 5 IT Media - Non Organic" },
  { originID: 2121, value: "700 5 Acquire Interactive - Non Organic" },
  { originID: 2122, value: "700 50 LoanCall - Organic " },
  { originID: 2123, value: "700 5 LoanCall - Non Organic" },
  { originID: 2124, value: "700 50 Lead Toro - Organic" },
  { originID: 2125, value: "700 5 Lead Toro - Non Organic" },
  { originID: 2126, value: "700 50 Arrow Shade - Organic" },
  { originID: 2127, value: "700 5 Arrow Shade - Non Organic" },
  { originID: 2128, value: "700 50 Intimate Interactive  " },
  { originID: 2129, value: "700 50 The Lead Group " },
  { originID: 2130, value: "700 50 Round Sky  " },
  { originID: 2131, value: "700 50 Acquire Interactive - Organic" },
  { originID: 2132, value: "700 50 Lead Flash  " },
  { originID: 2149, value: "700 Display Entercom" },
  { originID: 2150, value: "700 Social Entercom" },
  { originID: 2151, value: "700 Email Entercom" },
  { originID: 2152, value: "700 Flexpayday.com Short" },
  { originID: 2153, value: "700 Flexpayday.com Long" },
  { originID: 2154, value: "700 Grupo Estrella Phone Transfer " },
  { originID: 2155, value: "700 Grupo Estrella Website Traffic " },
  { originID: 2200, value: "700 100 Price Reject - Lead Flash" },
  { originID: 2201, value: "700 100 Price Reject - LoanCall" },
  { originID: 2202, value: "700 100 Price Reject - Lead Toro" },
  { originID: 2203, value: "700 100 Price Reject - Arrow Shade" },
  { originID: 2204, value: "700 100 Price Reject - Acquire Interactive" },
  { originID: 2205, value: "700 100 Price Reject - IT Media" },
  { originID: 2206, value: "700 100 Price Reject - Round Sky" },
  { originID: 2207, value: "700 100 Price Reject - The Lead Group  " },
  { originID: 2208, value: "700 100 Price Reject - Intimate Interactive" },
  { originID: 2209, value: "700 100 Price Reject - Acquire Interactive" },
  { originID: 2210, value: "700 100 Price Reject - Avenue Link" },
  { originID: 3101, value: "701 40 Intimate Interactive  " },
  { originID: 3102, value: "701 40 The Lead Group " },
  { originID: 3103, value: "701 40 Round Sky  " },
  { originID: 3104, value: "701 40 IT Media  " },
  { originID: 3105, value: "701 40 Acquire Interactive  " },
  { originID: 3106, value: "701 40 Lead Flash  " },
  { originID: 3107, value: "701 45 Intimate Interactive  " },
  { originID: 3108, value: "701 45 The Lead Group " },
  { originID: 3109, value: "701 45 Round Sky  " },
  { originID: 3110, value: "701 45 Acquire Interactive  " },
  { originID: 3111, value: "701 50 Intimate Interactive  " },
  { originID: 3112, value: "701 50 The Lead Group " },
  { originID: 3113, value: "701 50 Round Sky  " },
  { originID: 3114, value: "701 50 Acquire Interactive  " },
  { originID: 3115, value: "701 50 IT Media  " },
  { originID: 3116, value: "701 50 IT Media - Organic" },
  { originID: 3117, value: "701 20 IT Media - Non Organic" },
  { originID: 3118, value: "701 50 Acquire Interactive - Organic" },
  { originID: 3119, value: "701 20 Acquire Interactive - Non Organic" },
  { originID: 3120, value: "701 5 IT Media - Non Organic" },
  { originID: 3121, value: "701 5 Acquire Interactive - Non Organic" },
  { originID: 3122, value: "701 75 Leads Market - Organic" },
  { originID: 3123, value: "701 5 Leads Market - Non Organic" },
  { originID: 3124, value: "701 75 Lead Toro - Organic" },
  { originID: 3125, value: "701 5 Lead Toro - Non Organic" },
  { originID: 3126, value: "701 75 Arrow Shade - Organic" },
  { originID: 3127, value: "701 5 Arrow Shade - Non Organic" },
  { originID: 3128, value: "701 50 Dot818" },
  { originID: 3129, value: "701 75 YA Solutions - Organic" },
  { originID: 3130, value: "701 5 YA Solutions - Non Organic" },
  { originID: 3131, value: "701 75 IT Media - Organic" },
  { originID: 3132, value: "701 75 Intimate Interactive - Organic" },
  { originID: 3133, value: "701 75 The Lead Group - Organic" },
  { originID: 3134, value: "701 75 Round Sky - Organic" },
  { originID: 3135, value: "701 75 Acquire Interactive - Organic" },
  { originID: 3136, value: "701 75 Lead Flash - Organic" },
  { originID: 3137, value: "701 75 Dot818 - Organic " },
  { originID: 3138, value: "701 77 Intimate Interactive - Organic" },
  { originID: 3139, value: "701 77 The Lead Group - Organic" },
  { originID: 3140, value: "701 77 Round Sky - Organic" },
  { originID: 3141, value: "701 77 IT Media - Organic" },
  { originID: 3142, value: "701 77 Acquire Interactive - Organic" },
  { originID: 3143, value: "701 77 Dot818 - Organic " },
  { originID: 3144, value: "701 77 Arrow Shade - Organic" },
  { originID: 3145, value: "701 77 YA Solutions - Organic" },
  { originID: 3146, value: "701 77 Lead Toro - Organic" },
  { originID: 3147, value: "701 77 Leads Market - Organic" },
  { originID: 3148, value: "701 77 Lead Flash - Organic" },
  { originID: 3149, value: "701 Display Entercom" },
  { originID: 3150, value: "701 Social Entercom" },
  { originID: 3151, value: "701 Email Entercom" },
  { originID: 3152, value: "701 Flexpayday.com Short" },
  { originID: 3153, value: "701 Flexpayday.com Long" },
  { originID: 3154, value: "701 100 Price Reject - Lead Flash" },
  { originID: 3155, value: "701 100 Price Reject - Leads Market" },
  { originID: 3156, value: "701 100 Price Reject - Lead Toro" },
  { originID: 3157, value: "701 100 Price Reject - YA Solutions" },
  { originID: 3158, value: "701 100 Price Reject - Arrow Shade" },
  { originID: 3159, value: "701 100 Price Reject - Dot818" },
  { originID: 3160, value: "701 100 Price Reject - Acquire Interactive" },
  { originID: 3161, value: "701 100 Price Reject - IT Media" },
  { originID: 3162, value: "701 100 Price Reject - Round Sky" },
  { originID: 3163, value: "701 100 Price Reject - The Lead Group  " },
  { originID: 3164, value: "701 100 Price Reject - Intimate Interactive" },
  { originID: 3165, value: "701 75 Installment - Lead Flash" },
  { originID: 3166, value: "701 75 Installment - Leads Market" },
  { originID: 3167, value: "701 75 Installment - Lead Toro" },
  { originID: 3168, value: "701 75 Installment - YA Solutions" },
  { originID: 3169, value: "701 75 Installment - Arrow Shade" },
  { originID: 3170, value: "701 75 Installment - Dot818 " },
  { originID: 3171, value: "701 75 Installment - Acquire Interactive" },
  { originID: 3172, value: "701 75 Installment - IT Media" },
  { originID: 3173, value: "701 75 Installment - Round Sky" },
  { originID: 3174, value: "701 75 Installment - The Lead Group" },
  { originID: 3175, value: "701 75 Installment - Intimate Interactive" },
  { originID: 3176, value: "Flexpayday Home Page" },
  { originID: 3177, value: "701 50 Installment - Lead Flash" },
  { originID: 3178, value: "701 50 Installment - Leads Market" },
  { originID: 3179, value: "701 50 Installment - Arrow Shade" },
  { originID: 3180, value: "701 50 Installment - Acquire Interactive" },
  { originID: 3181, value: "701 50 Installment - Round Sky" },
  { originID: 3182, value: "701 50 Installment - Lead Group" },
  { originID: 3183, value: "701 50 Installment - Intimate Interactive" },
  { originID: 3184, value: "701 100 Price Reject - Avenue Link" },
  { originID: 3185, value: "701 50 Installment - Dot818 " },
  { originID: 3186, value: "701 50 Installment - IT Media" },
  { originID: 3187, value: "701 43 Installment - Acquire Interactive" },
  { originID: 3188, value: "701 32 Installment - IT Media" },
  { originID: 3189, value: "Installment - Dot818" },
  { originID: 3190, value: "701 36 Installment - Leads Market" },
  { originID: 3191, value: "Installment - Arrowshade" },
  { originID: 4101, value: "703 100 Price Reject - Acquire Interactive" },
  { originID: 4102, value: "703 100 Price Reject - IT Media" },
  { originID: 4103, value: "703 100 Price Reject - Leads Market" },
  { originID: 4104, value: "703 100 Price Reject - Arrowshade" },
  { originID: 4201, value: "703 35 Static - Acquire Interactive" },
  { originID: 4202, value: "703 35 Static - IT Media" },
  { originID: 4203, value: "703 35 Static - Leads Market" },
  { originID: 4204, value: "703 35 Static - Arrowshade " },
  { originID: 4205, value: "703 35 Static - Dot818 " },
];

export const PeriodsLookup = [
  { label: "Week", value: "Week" },
  { label: "Midnight", value: "Midnight" },
  { label: "Day", value: "Day" },
  { label: "Month", value: "Month" },
];

export const PathtypesButtons = [
 'Regular',
 'UnderwriteButton',
 'UnderwriteFlexButton',
 'FraudCheck'
 ];

 export enum Pathtypesenum
 {
  'Regular',
  'UnderwriteButton',
  'UnderwriteFlexButton',
  'FraudCheck'
 };

 export const customerTypesArr = [
  'IneligibleReturn',
  'ActiveReturn',
  'InactiveReturn',
  'Retention',
  'UnconvertedApproval',
  'NewCustomer',
];
